/* global webpack */

import angular from 'angular'
import Clipboard from 'clipboard'

import envRaw from '../utils/env-raw'
import Emitter from '../utils/emitter'
import attachGetters from '../utils/attach-getters'
import extractRawElm from '../utils/extract-raw-elm'
import attachEmitters from '../utils/attach-emitters'

import { wrap, clone, partial, uniqueId } from 'lodash-es'
import { makeOR, safeAssign } from '../utils/bits'

import { toUrl } from '../utils/security'
import { embedModal } from '../utils/shared-constants'

import Template from './gallery-code-wizard.component.ejs'
import CLIPBOARD_ICON from '../../img/code-wizard-icons/clipboard.svg'

const {
  HOR_ALIGN_CONFIG_DEFAULT,
  VER_ALIGN_CONFIG_DEFAULT,
  MAX_WIDTH_CONFIG_DEFAULT,
  MAX_HEIGHT_CONFIG_DEFAULT
} = embedModal

angular
  .module('ggs.gallery-code-wizard')
  .component('ggsGalleryCodeWizard', {
    template: Template({
      LE: envRaw.liveEditMode,
      CLIPBOARD_ICON
    }),
    controller: GalleryCodeWizardComponent,
    bindings: {
      ggsPost: '<',
      ggsSlideIndex: '<',
      ggsProperties: '<',
      ggsIsTinyLayout: '<',
      ggsCodeWizardAttachCallback: '<',
      ggsCodeWizardDiscardHandler: '<',
      ggsCodeWizardCompleteHandler: '<'
    }
  })

const BASE_URL_PLH = ':base_url:'
const TERMS_URL_TMPL = `${BASE_URL_PLH}/terms`

const QS_COPIED = '.ggs-gallery-code-wizard__copied-block'
const QS_COPY_BUTTON = '.ggs-gallery-code-wizard__copy-button'

const DEFAULT_CONFIG = {
  horAlign: HOR_ALIGN_CONFIG_DEFAULT,
  verAlign: VER_ALIGN_CONFIG_DEFAULT,
  maxWidth: MAX_WIDTH_CONFIG_DEFAULT,
  maxHeight: MAX_HEIGHT_CONFIG_DEFAULT
}

const CLICK_EVENT = envRaw.galleryCodeWizardClickEvent

function GalleryCodeWizardComponent(
  $log,
  $scope,
  $element,
  qh,
  domh,
  animate,
  postShare,
  StayInQueue,
  DefineMethod,
  DefineHandler) {

  $scope.CLICK_EVENT = CLICK_EVENT

  const sign = `galleryCodeWizard[uid=${uniqueId()}]`
  const $ctrl = $scope.$ctrl = attachGetters(this)
  $ctrl.wrapH = DefineHandler(sign)
  $ctrl.wrapM = DefineMethod(sign)
  const stayInQueue = StayInQueue(sign)

  const copiedElm = domh.find($element, QS_COPIED)

  $ctrl.termsUrl = toUrl(TERMS_URL_TMPL.replace(BASE_URL_PLH, webpack.apiServerHost))

  $ctrl.config = clone(DEFAULT_CONFIG)
  $ctrl.configEmitter = Emitter(`${sign}:config`)

  $ctrl.getShareCode = attachEmitters(
    $ctrl.configEmitter,
    partial(
      postShare.fmtCode,
      $ctrl.config,
      $ctrl.ggsPost,
      $ctrl.ggsProperties,
      $ctrl.getters.ggsSlideIndex))

  const clipboard = new Clipboard(domh.find($element, QS_COPY_BUTTON), {
    text: $ctrl.getShareCode,
    container: extractRawElm($element)
  })

  $ctrl.isTinyLayout = attachEmitters(
    $ctrl.ggsIsTinyLayout,
    $ctrl.ggsProperties.key2emitter.code_wizard_force_tiny,
    makeOR(
      $ctrl.ggsIsTinyLayout,
      $ctrl.ggsProperties.key2get.code_wizard_force_tiny))

  $ctrl.wrapM('reset', () => {
    // reset state
    safeAssign($ctrl.config, DEFAULT_CONFIG)
    $ctrl.configEmitter.emit()
    // reset elements
    return animate.hideForce(copiedElm)
  })

  $ctrl.wrapM('extCodeWizardReset',
    $ctrl.reset)

  $ctrl.wrapM('showCopied',
    animate.makeShow(copiedElm))

  $ctrl.wrapM('waitUser',
    qh.makeDelay(2e3))

  $ctrl.wrapH('clipboardSuccessHandler',
    stayInQueue.makeIfIdle(
      qh.makeOver(
        $ctrl.showCopied,
        $ctrl.waitUser,
        $ctrl.ggsCodeWizardCompleteHandler)))

  $ctrl.wrapH('clipboardProblemHandler',
    wrap(`${sign}#clipboardProblemHandler:`, $log.error))

  $ctrl.wrapH('closeButtonClickHandler',
    stayInQueue.makeIfIdle(
      $ctrl.ggsCodeWizardDiscardHandler))

  $ctrl.wrapH('$onDestroy', () => {
    clipboard.off('success', $ctrl.clipboardSuccessHandler)
    clipboard.off('error', $ctrl.clipboardProblemHandler)
    clipboard.destroy()
  })

  $ctrl.wrapH('$onInit', () => {
    clipboard.on('success', $ctrl.clipboardSuccessHandler)
    clipboard.on('error', $ctrl.clipboardProblemHandler)
    return qh.join($ctrl.reset(), $ctrl.ggsCodeWizardAttachCallback($ctrl.extCodeWizardReset))
  })
}
